import React, { useEffect } from "react";
import { connect } from "react-redux";
import { getInfoCabecalho } from "../Adesao/action";
import { Row, Col } from "antd";
import { useParams, Navigate } from "react-router-dom";
import BarraInformacao from "../../Components/BarraInformacao";
import BarLoader from "react-spinners/BarLoader";
import "./style.scss";
import FolowupProcessosInflamatorios from "Components/FolowupProcessosInflamatorios";
import OpcoesRotina from "Pages/Rotina/OpcoesRotina";
import { getFollowUpProcessosInflamatorios } from "./action";

const ProcessosInflamatorios = props => {
  const { tarefa, tipo } = useParams();
  useEffect(() => {
    
    props.getInfoCabecalho(props.user.id, tarefa, tipo);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tarefa]);

  useEffect(() => { 
    if (props.paciente) props.getFollowUpProcessosInflamatorios(props.paciente, tarefa)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.paciente])
  return (
    <>
      {!tarefa && <Navigate to="/" replace />}
      <BarraInformacao />
      {!props.loading ? (
        <Row className={"layout-rotina"}>
          <Col className={"coluna-folloup"}>
            <FolowupProcessosInflamatorios />
          </Col>
          <Col className={"coluna-body"}>
            <OpcoesRotina />
          </Col>
        </Row>
      ) : (
          <BarLoader color={"#0F79B2"} width={"100vw"} />
        )}
    </>
  );
};

const mapStateToProps = store => ({
  paciente: store.adesao.paciente,
  loading: store.barrainformacao.loading,
  perguntas: store.processosInflamatorios.perguntas,
  user: store.login.user
});

const mapDispatchToProps = dispatch => ({
  getInfoCabecalho: (enfermeiroID, tarefaID, tipo) =>
    dispatch(getInfoCabecalho(enfermeiroID, tarefaID, tipo)),
    getFollowUpProcessosInflamatorios: (paciente,tarefa) => dispatch(getFollowUpProcessosInflamatorios(paciente, tarefa))
});

export default connect(mapStateToProps, mapDispatchToProps)(ProcessosInflamatorios);
